import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import config from "../../config/config";
import axios from "axios";
// import DataTable from "react-data-table-component";
// import { Link } from "react-router-dom";
import Loader from "../Loader/Loader";
//MUI Table
import { MaterialReactTable } from "material-react-table";
// import { MenuItem } from "@mui/material";
import { Box, Button, Modal } from "@mui/material";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import { checkUserPermission } from "../../common/UserPermission";
import moment from "moment";
import CommonMultiSelect from "../MultiSelect/CommonMultiSelect";

// import { toastSuccess } from "../../../../common/Toast";
// import { DELETE_MESSAGE } from "../../../../common/Constant";

const FilterModal = ({
  callback,
  runApi,
  closepopup,
  customerId = 0,
  supplierID = 0,
}) => {
  // const history = useNavigate();
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  // console.log(callback, runApi, "runrun")
  const Location = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const [showModal, setShowModal] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagData, setTagData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [supplierData, setSupplierData] = useState([]);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchtext, setSearchText] = useState("");
  const [perPageSize, setperPageSize] = useState();
  const [toggled, setToggled] = useState(false);
  const [showFrequentlyPurchased, setShowFrequentlyPurchased] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    label: "All Items",
    value: 0,
  });

  const onToggle = () => {
    setToggled((t) => !t);
  };

  // const onToggleChange = () => {
  //   setShowFrequentlyPurchased((prevState) => !prevState);
  //   // handleListData();
  // };

  const [sortingId, setSortingId] = useState(2);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [toggledClearRows, setToggleClearRows] = React.useState(false);
  const [selectCheckbox, setSelectCheckbox] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const [newQtyToAll, setNewQtyToAll] = useState("");

  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [lockdata, setlockdata] = useState([]);

  console.log(rowSelection, "rowSelection");

  // material model popup
  const [open, setOpen] = useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setGlobalFilter("");
    setData([]);
    setOpen(false);
    closepopup();
    localStorage.removeItem("Lockedvalue");
    setlockdata([]);
  };

  console.log(data, "Filtefedata ==>");

  const storedIDs = JSON.parse(localStorage.getItem("selectedRowIDs") || "[]");

  console.log(storedIDs, "localstorage");
  const handleClick = (row) => {
    setSelectCheckbox(true);
    // setData([])
    console.log(row, toggledClearRows, "65465");
    const selectedIds = row.map((x) => ({ ...x, ReceivingId: 0 }));
    // callback(row.map((el) => el.original));

    const data = row.map((el) => el.original);
    const mapToObjectFormat = (input) => ({
      RowNumber: input?.RowNumber,
      ItemId: input?.ID,
      VariationName: input?.VariationName,
      UnitPrice: input?.Unitprice === null ? 0 : input?.Unitprice,
      CostPrice: input?.Costprice,
      PromoPrice: input?.PromoPrice,
      VariationQuantity: input?.VariationQuantity,
      ItemName: input?.Name,
      Description: input?.Description,
      CategoryName: input?.Categoryfullpath,
      Itemquantity: input?.Quantity,
      VariationId: input?.VariationId,
      AccountName: input?.AccountName,
      ChartOfAccountName: input?.ChartOfAccountName,
      AccountTypeName: input?.AccountTypeName,
      AccountDeatilsTypeName: input?.AccountDeatilsTypeName,
      Module: input?.Module,
      CategoryID: input?.CategoryID,
      ImageName: input?.ImageURL,
      Itemnumber: input?.Itemnumber,
      Allowaltdescription: input?.Allowaltdescription,
      IsItemserialnumber: input?.IsItemserialnumber,
      SupplierID: input?.SupplierID,
      Tier1: input?.Tier1,
      Tier2: input?.Tier2,
      Tier3: input?.Tier3,
      Tier4: input?.Tier4,
      Tier5: input?.Tier5,
      RecallPrice: input?.RecallPrice,
      Lable: input?.Lable,
      SupplierName: input?.Supplier,
      TagName: input?.Tags,
      TotalRecord: input?.TotalRecord,
      ReceivingId: input?.ReceivingId,
      Price: input?.Price === null ? 0 : input?.Price,
      itemquickbookid: Number(input?.QuickbookId),
      isReCallPrice: input?.isReCallPrice,
      newQty: input?.newQty ? input?.newQty : 0,
    });

    const outputArray = data.map(mapToObjectFormat);

    setGlobalFilter("");
    setNewQtyToAll("");
    setData([]);
    callback(outputArray);
    setOpen(false);
    localStorage.removeItem("selectedRowIDs");
    closepopup();
  };

  const changeQtyOnItemGrid = (value, index) => {
    let updateRowData = [...data];
    const qty = value ? Number(value) : "";

    updateRowData[index].newQty = qty;
    setData(updateRowData);

    // Get the row and its id
    const row = updateRowData[index];
    const id = row?.VariationId > 0 ? row.VariationId : row?.ID;

    console.log(row, "8575487");

    if (id) {
      // Get existing storage as object
      const storedIds = JSON.parse(
        localStorage.getItem("selectedRowIDs") || "{}"
      );

      // Update or add the new quantity for this id
      storedIds[id] = qty;

      // Save updated object back to localStorage
      localStorage.setItem("selectedRowIDs", JSON.stringify(storedIds));
    }

    // Update row selection state
    setRowSelection((prevSelection) => ({
      ...prevSelection,
      [index]: !!qty,
    }));
  };

  const HandleLockedItem = (row) => {
    const Lockedvalue = JSON.parse(localStorage.getItem("Lockedvalue") || "[]");

    Lockedvalue.push(row);

    localStorage.setItem("Lockedvalue", JSON.stringify(Lockedvalue));

    const Lockedvalues = JSON.parse(
      localStorage.getItem("Lockedvalue") || "[]"
    );

    setlockdata(Lockedvalues);
  };

  const handleshowdata = () => {
    const Lockedvalues = JSON.parse(
      localStorage.getItem("Lockedvalue") || "[]"
    );

    setData(Lockedvalues);
    setRowSelection(Lockedvalues);
  };

  const handelApplytoAllNewQty = (row) => {
    console.log(row, "selected");
    let updateRowData = [...data];
    row.map((index) => {
      updateRowData[index].newQty = newQtyToAll ? Number(newQtyToAll) : 0;
    });

    setData(updateRowData);
  };

  const options = [
    { value: 0, label: "All Items" }, // This will be default selected
    { value: 1, label: "Frequently Purchased" },
    { value: 2, label: "Recently Purchased" },
    { value: 3, label: "Most Profitable" },
  ];

  const handleChange = (event) => {
    setSelectedOption(event);
    console.log("Selected option:", event);
  };

  const handleTagIds = (e) => {
    setSelectedTags(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleCategoriesIds = (e) => {
    setSelectedCategories(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleSupplierIds = (e) => {
    setSelectedSupplier(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleBrandsIds = (e) => {
    setSelectedBrand(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  let tagsOption = [];
  const Tags = tagData.map((u, i) => {
    tagsOption[i] = { label: u.Name, value: u.ID };
  });
  let categoriesOption = [];
  const Categories = categoriesData.map((u, i) => {
    categoriesOption[i] = { label: u.Name, value: u.ID };
  });
  let supplierOption = [];
  const Suppliers = supplierData.map((u, i) => {
    // supplierOption[i] = { label: u.FirstName, value: u.ID };
    supplierOption[i] = {
      label: u.CompanyName + "(" + u.FirstName + " " + u.LastName + ")",
      value: u.ID,
    };
  });

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    selectedTags,
    selectedCategories,
    selectedSupplier,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    selectedBrand,
    selectedOption,
    clearSelection = false
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    console.log(globalFilter, "FilterColumnSearchText");
    const isShowSaleItems =
      (customerId || supplierID) > 0 ? selectedOption.value : 0;

    axios
      .get(
        `${
          config.itemsBaseUrl
        }/items/itemselectionlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined
            ? ""
            : encodeURIComponent(globalFilter.trim())
        }&startdate=&enddate=&categoryid=${selectedCategories}&tagid=${selectedTags}&filtersupplier=${selectedSupplier}&LocationID=${Location}&CustomerID=${customerId}&BrandId=${selectedBrand}&showFrequentlyPurchased=${isShowSaleItems}&supplierid=${supplierID}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const storedObj = JSON.parse(
          localStorage.getItem("selectedRowIDs") || "[]"
        );
        const newData = res.data.ResponseData.map((item) => {
          const id = item.VariationId > 0 ? item.VariationId : item.ID;
          const qtyget = storedObj[id]; // value from localStorage object

          return {
            ...item,
            ReceivingId: 0,
            newQty: qtyget || "", // if qtyget is undefined, fallback to ""
          };
        });

        setTotalRows(newData[0]?.TotalRecord);

        const storedIDs = Object.keys(storedObj).map(Number);
        const restoredSelection = {};

        newData.forEach((row, index) => {
          const idToCheck = row.VariationId > 0 ? row.VariationId : row.ID;
          if (storedIDs.includes(idToCheck)) {
            restoredSelection[index] = true;
          }
        });

        setRowSelection(restoredSelection);

        setData(newData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Portal`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagData(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setCategoriesData(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSupplierData(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.brandBaseUrl}/brands/brandsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const datalist = res.data.ResponseData.map((u) => {
          return { label: u.Name, value: u.ID };
        });

        setBrands(datalist);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  // const responseString = selectedSupplier?.join(",");

  useEffect(() => {
    if (runApi) {
      setOpen(true);
      handleListData(
        1,
        perPageSize,
        searchtext,
        sortingId,
        sortingDirection,
        selectedTags ? selectedTags : "",
        selectedCategories ? selectedCategories : "",
        selectedSupplier,
        columnFilters,
        globalFilter,
        pagination,
        sorting,
        selectedBrand,
        selectedOption
      );
    }
    // handleListData(1);
  }, [
    // perPageSize,
    // searchtext,
    // sortingId,
    // sortingDirection,
    selectedTags,
    selectedCategories,
    selectedSupplier,
    runApi,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    selectedBrand,
    selectedOption,
    // selectCheckbox
  ]);

  const columns = useMemo(() => [
    {
      header: "Lock",
      accessorKey: "IDs",
      size: 110,
      Cell: ({ row }) => {
        return (
          <div
            className="cursor-pointer mt-2"
            title="Lock Your Sequence"
            onClick={() => HandleLockedItem(row.original)}
          >
            <i className="fa fa-lock columnsLock fs-4"></i>
          </div>
        );
      },
    },
    {
      header: "ItemId",
      accessorKey: "ID",
      size: 110,
      Cell: ({ row }) =>
        row.original.VariationId > 0
          ? row.original.ID + "#" + row.original.VariationId
          : row.original.ID,
    },
    {
      header: "UPC/EAN/ISBN",
      accessorKey: "Itemnumber",
      size: 110,
    },
    {
      header: "Item Name",
      accessorKey: "Name",
      Cell: ({ row }) => {
        return (
          <div className="word-break-data" title={row.original.Name}>
            {row.original.VariationId != 0
              ? row.original.VariationName
              : row.original.Name}
          </div>
        );
      },
    },
    {
      header: supplierID > 0 ? "QTY Received" : "Qty Purchased",
      accessorKey: "TotalQuantityPurchased",
      size: 150,
      hidden: selectedOption.value === 1 ? true : false, // Hide based on condition
    },
    {
      header: "Purchased Date",
      accessorKey: "LastPurchaseDate",
      size: 150,
      hidden: selectedOption.value === 2 ? true : false, // Hide based on condition
      Cell: ({ row }) =>
        moment(row.original.LastPurchaseDate).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Category",
      accessorKey: "Categoryfullpath",
      size: 100,
    },
    {
      header: "Cost Price",
      accessorKey: "Costprice",
      size: 100,
      Cell: ({ row }) =>
        parseFloat(
          row.original.Costprice > 0 ? row.original.Costprice : 0
        ).toFixed(2),
      hidden: toggled == true ? true : false,
    },
    {
      header: supplierID > 0 ? "Cost price" : "Unit Price",
      accessorKey: supplierID > 0 ? "Costprice" : "Unitprice",
      size: 100,
      Cell: ({ row }) =>
        supplierID > 0
          ? parseFloat(
              row.original.Costprice > 0 ? row.original.Costprice : 0
            ).toFixed(2)
          : parseFloat(
              row.original.RecallPrice > 0 ? row.original.RecallPrice : row.original.Unitprice > 0 ? row.original.Unitprice : 0
            ).toFixed(2),
    },
    {
      header: "Qty.",
      accessorKey: "Quantity",
      size: 100,
      Cell: ({ row }) =>
        parseFloat(
          row.original.Quantity !== null ? row.original.Quantity : 0
        ).toFixed(2),
    },
    {
      header: "New Qty",
      accessorKey: "newQty",
      size: 130,
      Cell: ({ row, table, staticRowIndex }) => {
        const isShow = table
          .getSelectedRowModel()
          .rows.map((el) => el.index)
          .some((el) => el === row.index);
        return (
          <div>
            {/* {isShow && ( */}
            <input
              name="newQty"
              type="number"
              value={row.original.newQty}
              onChange={(e) => changeQtyOnItemGrid(e.target.value, row.index)}
              className="form-control h-100 w-60"
            ></input>
            {/* )} */}
          </div>
        );
      },
    },
    {
      header: "Images",
      accessorKey: "ImageURL",
      size: 100,
      Cell: ({ row }) => {
        return (
          <>
            {row.original.ImageURL != "NO IMAGE" ? (
              <a target="_blank" href={row.original.ImageURL}>
                <img
                  src={
                    row.original.ImageURL
                      ? row.original.ImageURL
                      : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                  }
                  style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
                />
              </a>
            ) : (
              <img
                src={
                  row.original.ImageURL != "NO IMAGE"
                    ? row.original.ImageURL
                    : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                }
                style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
              />
            )}
          </>
        );
      },
    },
    {
      header: "Tag",
      accessorKey: "Tags",
      size: 120,
    },
    {
      header: "Brand",
      accessorKey: "Brand",
      size: 120,
    },
    {
      header: "Supplier",
      accessorKey: "Supplier",
      Cell: ({ row }) => {
        return (
          <p className="word-break-data" title={row.original.Supplier}>
            {row.original.Supplier != null ? row.original.Supplier : ""}
          </p>
        );
      },
    },
  ]);
  //  const visibleColumns = columns.filter((columns) => columns.hidden !== false);

  const visibleColumns = columns.filter((column) => column.hidden !== false);

  const style = {
    height: 848,
    bgcolor: "background.paper",
    border: "2px solid #000",
    // boxShadow: 24,
    p: 1,
  };

  const handleRowSelectionChange = (updater) => {
    const updatedSelection =
      typeof updater === "function" ? updater(rowSelection) : updater;

    const newSelectedIds = Object.keys(updatedSelection)
      .map((key) =>
        data?.[key]?.VariationId > 0 ? data[key].VariationId : data[key]?.ID
      )
      .filter(Boolean);

    const storedIds = JSON.parse(
      localStorage.getItem("selectedRowIDs") || "[]"
    );

    const mergedIds = Array.from(new Set([...storedIds, ...newSelectedIds]));

    localStorage.setItem("selectedRowIDs", JSON.stringify(mergedIds));
    setRowSelection(updatedSelection);
  };

  useEffect(() => {
    console.log(lockdata, "@@@");

    localStorage.removeItem("selectedRowIDs");
    localStorage.removeItem("Lockedvalue");
    setlockdata([]);
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <div>
        {/* <Button onClick={handleOpen}>Open modal</Button> */}
        <Modal
          open={open}
          he
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div style={{height:"50px"}} className="d-flex justify-content-between">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "flex-start",
                }}
                className="custom-header"
              >
                <p className="title-model" id="exampleModalLabel">
                  Filter
                </p>
                {/* {customerId > 0  ( */}
                <div className="col-md-4">
                  <Select
                    defaultValue={selectedOption}
                    onChange={(event) => handleChange(event)}
                    // value={options.find(
                    //   (el) => el.value == selectedOption
                    // )}
                    options={options}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-select-search"
                    // isClearable={true}
                    backspaceRemovesValue={false}
                    id="selector"
                  />
                </div>
                {/*  )} */}
                <div className="col-auto">
                  <div className="input-group">
                    {/* <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isMulti={true}
                    isClearable={true}
                    onChange={handleCategoriesIds}
                    options={categoriesOption}
                    placeholder="Select Category"
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    value={categoriesOption.filter((obj) =>
                      selectedCategories.includes(obj.value)
                    )}
                    id="CategoriesIds"
                    name="CategoriesIds"
                    className="w-100 custom-search-select"
                  /> */}
                    <CommonMultiSelect
                      options1={categoriesOption}
                      callbackvalue={setSelectedCategories}
                      placeholder="Categories"
                      // styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      // value={brands.find((el) => el.value == selectedBrand)}
                      // id="Category"
                      // name="Category"
                      className="w-100 custom-search-select"
                    />
                  </div>
                </div>
                <div className="col-auto">
                  {/* {checkUserPermission("/suppliers") && ( */}
                  <div className="input-group">
                    {/* <Select
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isMulti={true}
                      isClearable={true}
                      onChange={handleBrandsIds}
                      options={brands}
                      placeholder="Select Brand"
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      value={brands.filter((obj) =>
                        selectedBrand.includes(obj.value)
                      )}
                      id="brands"
                      name="brands"
                      className="custom-search-select w-100"
                    /> */}
                    <CommonMultiSelect
                      options1={brands}
                      callbackvalue={setSelectedBrand}
                      placeholder="brands"
                      // styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      // value={brands.find((el) => el.value == selectedBrand)}
                      // id="Category"
                      // name="Category"
                      className="w-100 custom-search-select"
                    />
                  </div>
                  {/* )} */}
                </div>
                <div className="col-auto">
                  {checkUserPermission("/suppliers") && (
                    <div className="input-group">
                      {/* <Select
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isMulti={true}
                      isClearable={true}
                      onChange={handleSupplierIds}
                      options={supplierOption}
                      placeholder="Select Supplier"
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      value={supplierOption.filter((obj) =>
                        selectedSupplier.includes(obj.value)
                      )}
                      id="SupplierIds"
                      name="SupplierIds"
                      className="custom-search-select w-100"
                    /> */}
                      <CommonMultiSelect
                        options1={supplierOption}
                        callbackvalue={setSelectedSupplier}
                        placeholder="Supplier"
                        // styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        // value={brands.find((el) => el.value == selectedBrand)}
                        // id="Category"
                        // name="Category"
                        className="w-100 custom-search-select"
                      />
                    </div>
                  )}
                </div>
                <div className="col-auto">
                  <div className="input-group">
                    {/* <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isMulti={true}
                    isClearable={true}
                    onChange={handleTagIds}
                    options={tagsOption}
                    placeholder="Select Tags"
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    value={tagsOption.filter((obj) =>
                      selectedTags.includes(obj.value)
                    )}
                    id="TagsIds"
                    name="TagsIds"
                    className="w-100 custom-search-select"
                  /> */}
                    <CommonMultiSelect
                      options1={tagsOption}
                      callbackvalue={setSelectedTags}
                      placeholder="Tags"
                      // styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      // value={brands.find((el) => el.value == selectedBrand)}
                      // id="Category"
                      // name="Category"
                      className="w-100 custom-search-select"
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleshowdata()}
                  >
                    {" "}
                    Show Item ( {lockdata.length} )
                  </button>
                </div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            {data && (
              <MaterialReactTable
                columns={visibleColumns}
                data={data}
                // tableRef={tableRef}
                enableColumnResizing
                muiTableBodyProps={{
                  sx: () => ({
                    "& tr:nth-of-type(even)": {
                      backgroundColor: "var(--datatable-row-background-color)",
                      //'rgb(237 237 233 / 63%)'
                    },
                    "& td": {
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    },

                    "& tr": {
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    },
                  }),
                }}
                enableGrouping
                enableStickyHeader
                enableRowSelection
                enableColumnOrdering
                initialState={{
                  density: "compact",

                  pagination: { pageIndex: 0, pageSize: 10 },
                  columnOrder: [
                    "mrt-row-select",
                    "ID",
                    "Itemnumber",
                    "Name",
                    "TotalQuantityPurchased",
                    "LastPurchaseDate",
                    "Categoryfullpath",
                    "Costprice",
                    "Unitprice",
                    "Quantity",
                    "newQty",
                    "ImageURL",
                    "Tags",
                    "Brand",
                    "Supplier",
                  ],
                }}
                muiTableContainerProps={{
                  sx: {
                    maxHeight: { xs: 300, sm: 350, md: 420, lg: 450, xl: 550 },
                  },
                }}
                muiPaginationProps={{
                  rowsPerPageOptions: [10, 25, 50, 100, 300],
                }}
                muiTableBodyCellProps={{
                  sx: { borderLeft: "1px solid #E0E0E0" },
                }}
                muiTableHeadCellProps={{
                  sx: (theme) => ({
                    background: "var(--datatable-row-background-color)", //'#e9e9e9',
                    borderRight:
                      "1px solid var(--datatable-row-background-hover-color)",
                    lineHeight: "16px",
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "var(--primary-color-800)",
                    fontFamily: "Inter",
                  }),
                }}
                manualFiltering
                manualPagination
                manualSorting
                onColumnFiltersChange={setColumnFilters}
                onGlobalFilterChange={setGlobalFilter}
                onPaginationChange={setPagination}
                onSortingChange={setSorting}
                onRowSelectionChange={setRowSelection}
                rowCount={totalRows}
                state={{
                  columnFilters,
                  globalFilter,
                  isLoading,
                  pagination,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                  sorting,
                  rowSelection,
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      p: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    <div className="d-flex">
                      <div className="w-2 mt-3">New Qty:</div>
                      <input
                        name="New Qty:"
                        type="number"
                        value={newQtyToAll}
                        onChange={(e) => setNewQtyToAll(e.target.value)}
                        className="form-control w-5"
                      />

                      <button
                        type="button"
                        className="btn-sm btn-primary ml-3 w-5"
                        onClick={(e) =>
                          handelApplytoAllNewQty(
                            table
                              .getSelectedRowModel()
                              .rows.map((el) => el.index)
                          )
                        }
                      >
                        Apply to All
                      </button>
                      <button
                        type="button"
                        className="btn-sm btn-primary ml-3"
                        onClick={() => {
                          handleClick(table.getSelectedRowModel().rows);
                          localStorage.removeItem("Lockedvalue");
                          setlockdata([]);
                        }}
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                      >
                        Add
                      </button>
                    </div>
                    {checkUserPermission(PERMISSION_SHOW_COST_PRICE) && (
                      <div className="d-flex flex-row mt-3">
                        {/* <div className="col-md-12 "> */}
                        <div className="form-check form-switch mb-3 pull-right">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="toggle-button"
                            checked={toggled}
                            onChange={onToggle}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="toggle-button"
                          >
                            {toggled ? "Show Cost Price" : " Hide Cost Price"}
                          </label>
                        </div>
                        {/* </div> */}
                      </div>
                    )}
                  </Box>
                )}
              />
            )}
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default FilterModal;
